{
  "template": {
    "type": "share-block",
    "items": ["facebook", "vk", "telegram", "twitter", "linkedin"]
  }
}
